<template>
  <div id="app">
    <HeaderNav :data="HeaderNavData"></HeaderNav>
    <router-view />
    <FooterMap></FooterMap>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      HeaderNavData: {
        content: [
          {
            name: '首页',
            url: '/'
          },
          {
            name: '产品中心',
            url: '/product',
            content: [
              {
                name: '三维融合渲染平台',
                url: '/product/product3'
              },
              {
                name: 'VR全景三维可视化平台',
                url: '/product/product4'
              },
              {
                name: '二三维GIS地理信息平台',
                url: '/product/product1'
              },
              {
                name: '2.5D-GIS平台',
                url: '/product/product2'
              },

              {
                name: '室内地图可视化平台',
                url: '/product/product5'
              }
            ],
            show: false
          },
          {
            name: '开发中心',
            url: '/development'
          },
          {
            name: '行业应用',
            url: '/application'
          },
          {
            name: '经典案例',
            url: '/case',
            content: [
              {
                name: '经典案例',
                url: '/case'
              },
              {
                name: '动态案例',
                url: '/caseVideo'
              }
            ],
            show: false
          },
          {
            name: '数字孪生',
            url: '/digital'
          },
          {
            name: '服务中心',
            url: '/service'
          },
          // {
          //   name: "新闻动态",
          //   url: "/news"
          // },
          {
            name: '关于我们',
            url: '/about'
          },
          {
            name: '技术方案',
            url: 'http://www.ztmapinfo.com/blog/index.php'
          }
        ]
      }
    }
  },
  mounted() {
    this.setFontSize(); // 设置初始字体大小
    window.addEventListener('resize', this.setFontSize); // 监听窗口调整
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setFontSize); // 清理事件监听
  },
  methods: {
    setFontSize() {
      const width = window.innerWidth;
      const baseWidth = 375;
      const baseFontSize = 10; // 目标值，375px时1rem = 10px
      document.documentElement.style.fontSize = (baseFontSize * (width / baseWidth)) + 'px';
    }
  }
}
</script>

<style lang="less">

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #5db8fe;
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #5db8fe;
}
#app {
  font-family: "微软雅黑";
}
body, html {
  width: 100%;
  height: 100%;
}
ul {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}
.module {
  width: @contentWidth;
  margin: 0 auto;
}
.bannerTemp {
  height: 500px;
  background: no-repeat top center / auto 500px;
}
.productTitle {
  font-size: 38px;
  color: rgba(75, 75, 75, 1);
  span {
    font-size: 28px;
    color: #cccccc;
  }
}
.characteristics {
  height: 777px;
  background: url("./assets/images/product/bg4.png") no-repeat center center /
    cover;
  overflow: hidden;
  .productTitle {
    text-align: center;
    margin: 70px 0 40px 0;
  }
  .list {
    font-size: 0;
    > div {
      display: inline-block;
      width: 380px;
      height: 250px;
      background: #fff;
      margin-right: 24px;
      margin-bottom: 24px;
      box-shadow: 0px 0px 60px 10px rgba(13, 37, 62, 0.1);
      border-radius: 5px;
      text-align: center;
      vertical-align: top;
      padding: 0 50px;
      box-sizing: border-box;
      .title {
        font-size: 24px;
        color: rgba(2, 118, 247, 1);
        margin: 50px 0 20px 0;
      }
      .p {
        font-size: 20px;
        color: rgba(124, 124, 124, 1);
        line-height: 28px;
        text-align: left;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.productBanner {
  height: 813px;
  background: #fff url("./assets/images/index/banner_bg.jpg") no-repeat center
    center / 100% 100%;
  position: relative;
  .img {
    width: 789px;
    height: 703px;
    background: no-repeat center center;
    background-size: 789px 703px;
    top: 70px;
    right: 0;
    position: absolute;
  }
  .module {
    color: #fff;
    overflow: hidden;
    .h1 {
      font-size: 50px;
      line-height: 50px;
      margin: 172px 0 20px 0;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #fff;
    }
    .h2 {
      font-size: 30px;
      line-height: 30px;
      margin: 70px 0 20px 0;
    }
    .p {
      font-size: 20px;
      line-height: 28px;
      width: 500px;
    }
  }
}
.more {
  width: 156px;
  height: 48px;
  border-radius: 24px;
  border: 1px solid rgba(124, 124, 124, 1);
  font-size: 18px;
  color: rgba(75, 75, 75, 1);
  line-height: 48px;
  cursor: pointer;
  text-align: center;
  margin: 0 auto;
}
.overview {
  .productTitle {
    text-align: center;
    margin: 50px 0 40px 0;
  }
  .p {
    font-size: 16px;
    color: rgba(124, 124, 124, 1);
    line-height: 32px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue